export default __webpack_public_path__ + "static/media/image-5.ef9042c9.webp";